export const NAV = {
    logo: "nav-logo",
    home: "nav-home",
    programs: "nav-programs",
    calendar: "nav-calendar",
    login: "nav-login",
    signup: "nav-signup",
    dashboard: "nav-dashboard",
    logout: "nav-logout",
};

export const HOME = {
    heroRegisterBtn: "hero-register-btn",
    heroLearnBtn: "hero-learn-btn",
    programsGrid: "programs-grid",
    aboutSection: "about-section",
    ctaRegister: "cta-register",
    emergentLink: "emergent-link",
};

export const AUTH = {
    loginEmail: "login-email-input",
    loginPassword: "login-password-input",
    loginSubmit: "login-submit-btn",
    signupEmail: "signup-email-input",
    signupPassword: "signup-password-input",
    signupName: "signup-name-input",
    signupPhone: "signup-phone-input",
    signupSubmit: "signup-submit-btn",
};

export const PARENT = {
    addChildBtn: "add-child-btn",
    childForm: "child-form",
    firstName: "child-first-name",
    lastName: "child-last-name",
    dob: "child-dob",
    grade: "child-grade",
    gender: "child-gender",
    submitChild: "submit-child-btn",
    registerChildrenBtn: "register-children-btn",
    checkoutBtn: "checkout-btn",
    payBtn: "pay-btn",
    familyTab: "family-tab",
    tuitionTab: "tuition-tab",
    attendanceTab: "attendance-tab",
    reportCardsTab: "report-cards-tab",
    announcementsTab: "announcements-tab",
};

export const ADMIN = {
    statsCard: "admin-stats-card",
    usersTab: "admin-users-tab",
    classesTab: "admin-classes-tab",
    paymentsTab: "admin-payments-tab",
    announcementsTab: "admin-announcements-tab",
    eventsTab: "admin-events-tab",
    createTeacherBtn: "create-teacher-btn",
    createClassBtn: "create-class-btn",
    createAnnouncementBtn: "create-announcement-btn",
    createEventBtn: "create-event-btn",
    aiGenerateBtn: "ai-generate-desc-btn",
    markPaidBtn: "mark-paid-btn",
};

export const TEACHER = {
    classSelect: "teacher-class-select",
    rosterTable: "teacher-roster-table",
    attendanceTab: "teacher-attendance-tab",
    gradesTab: "teacher-grades-tab",
    saveAttendanceBtn: "save-attendance-btn",
    saveReportCardBtn: "save-report-card-btn",
};
